// 素材来源
export const MATERIAL_ORIGIN_TYPE = {
  OTHERS: 5,
  ADSITE: 1,
  CREATIVE_TOOL: 2,
  DPA: 3,
  MICRO_MOVIE: 4,
  QUICK_OPTIMIZATION: 6, // 一键优化
  VIDEO_TEMPLATE: 7, // 模版视频
  SMART_VIDEO_SOUNDTRACK: 8, // 智能配乐
  VIDEO_EDITOR: 9, // 视频编辑器
  TCPP: 10,
  VIDEO_GENERATOR_FROM_DPA: 11, // DPA模板生成工具
  DYNAMIC_VIDEO_GENERATOR_FROM_DPA: 12, // DPA动态生成工具
  TCM_VIDEO: 14,
  QUICK_GENERATION: 15, // 通过quick generation工具生成
  GIFT_VIDEO: 32,
  CC_VIDEO_UPLOAD: 16, //  创意平台上传
  CC_VIDEO_EDITOR: 84, // 创意中心视频编辑器生成
  CC_VIDEO_TEMPLATE: 85, // 创意中心视频模板生成
};

export const materialOrigin = [
  {
    id: MATERIAL_ORIGIN_TYPE.ADSITE,
    i18nKey: 'module_lib_source_filter_origin_creative_upload',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.DPA,
    i18nKey: 'module_lib_source_filter_dpa_upload',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.MICRO_MOVIE,
    i18nKey: 'module_lib_source_filter_creative_tools_smart_video',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.QUICK_OPTIMIZATION,
    i18nKey: 'module_lib_source_filter_quick_optimization',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.VIDEO_TEMPLATE,
    i18nKey: 'module_lib_source_filter_video_template',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.SMART_VIDEO_SOUNDTRACK,
    i18nKey: 'module_lib_source_filter_smart_video_soundtrack',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.VIDEO_EDITOR,
    i18nKey: 'module_lib_source_filter_video_editor',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.TCPP,
    i18nKey: 'module_lib_source_filter_tcpp',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.VIDEO_GENERATOR_FROM_DPA,
    i18nKey: 'module_lib_source_filter_video_generator_from_dpa',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.DYNAMIC_VIDEO_GENERATOR_FROM_DPA,
    i18nKey: 'module_lib_source_filter_dynamic_video_generator_from_dpa',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.TCM_VIDEO,
    i18nKey: 'module_lib_source_filter_tcm_video',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.GIFT_VIDEO,
    i18nKey: 'module_lib_source_filter_gift_video',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.OTHERS,
    i18nKey: 'module_lib_source_filter_other_video',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.QUICK_GENERATION,
    i18nKey: 'module_lib_source_filter_quick_generation',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.CC_VIDEO_UPLOAD,
    i18nKey: 'module_lib_source_filter_cc_video_upload',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.CC_VIDEO_EDITOR,
    i18nKey: 'module_lib_source_filter_cc_video_editor',
  },
  {
    id: MATERIAL_ORIGIN_TYPE.CC_VIDEO_TEMPLATE,
    i18nKey: 'module_lib_source_filter_cc_video_template',
  },
];

export const LIB_SEARCH_TYPE_ID_MAP = {
  SEARCH_CAMPAIGN: 1,
  SEARCH_ADGROUP: 2,
  SEARCH_AD: 3,
  SEARCH_VIDEO_MATERIAL: 4,
};

export const LIB_SEARCH_TYPES = [
  {
    id: LIB_SEARCH_TYPE_ID_MAP.SEARCH_CAMPAIGN,
    key: 'module_campaign_list_search_campaign',
  },
  {
    id: LIB_SEARCH_TYPE_ID_MAP.SEARCH_ADGROUP,
    key: 'module_campaign_list_search_adgroup',
  },
  {
    id: LIB_SEARCH_TYPE_ID_MAP.SEARCH_AD,
    key: 'module_campaign_list_search_ad',
  },
  {
    id: LIB_SEARCH_TYPE_ID_MAP.SEARCH_VIDEO_MATERIAL,
    key: 'module_library_table_search_video_material',
  },
];

// 非筛选项：搜索类型
export const videoSearchType = [
  {
    id: 1,
    key: 'common_Campaign',
  },
  {
    id: 2,
    key: 'common_AdGroup',
  },
  {
    id: 3,
    key: 'common_Ad',
  },
  {
    id: 4,
    key: 'common_video_material',
  },
];

export const nativePostSourceType = {
  adsManager: {
    value: 1,
    i18nKey: 'module_library_native_post_source_ads_manager',
  },
  marketingApi: {
    value: 2,
    i18nKey: 'module_library_native_post_source_marketing_api',
  },
  tcm: {
    value: 3,
    i18nKey: 'module_library_native_post_source_tcm',
  },
  rap: {
    value: 4,
    i18nKey: 'module_library_native_post_source_rap',
  },
};
